module.exports = __webpack_public_path__ + "img/editor.2e8f3e10.svg";